module.exports = __webpack_public_path__ + "img/active.4375baef.png";